import styles from "./Submission.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import Action from "../../components/Action/Action";

const data = [
  {
    _id: "sub1",
    name: "John Jacob",
    formStatus: "Completed",
    submissionDate: "02/05/2025",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "sub2",
    name: "John Jacob",
    formStatus: "Completed",
    submissionDate: "02/05/2025",
    actions: ["Edit", "Delete"],
  },
];

function Submission() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        name: item.name,
        formStatus: item.formStatus,
        submissionDate: item.submissionDate,
        actions: (
          <Action
            key={item._id}
            options={item.actions}
            onSelect={(opt) => {
              console.log(`Selected "${opt}" for ${item.name}`);
              dispatch(openModal("actionModal"));
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Name", accessor: "name" },
    { title: "Form Status", accessor: "formStatus" },
    { title: "Submission Date", accessor: "submissionDate" },
    { title: "Actions", accessor: "actions" },
  ];

  return (
    <div className={styles.headerContainer}>
      <div className={styles.resultandcount}>
        <ResultAndCount
          label="Total Forms Approved"
          count={10}
          bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Total Forms Rejected"
          count={2}
          bgColor="rgba(from var(--Primary_Color) r g b / 0.2)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Total Forms Interview"
          count={5}
          bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Total Forms Pending"
          count={1}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.4)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Total Forms Review"
          count={3}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.2)"
          textColor="Black_Color"
        />
      </div>

      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search activity"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <Dropdown
              label="Rooms"
              options={["Room 1", "Room 2"]}
              bgColor="rgba(240, 240, 240, 1)"
            />
            <Dropdown
              label="Submission Date"
              options={["Latest", "Oldest"]}
              bgColor="rgba(240, 240, 240, 1)"
            />
          </div>
        </div>

        <div className={styles.dynamicdata}>
          <DynamicTable
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default Submission;
